<!--
 * @Author: mazhigang
 * @Date: 2023-05-29 16:31:42
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-10-13 16:56:38
-->
<template>
  <div class="box_left">
    <div style="display: flex;position: relative;height: 100%;">
      <div class="item_box">
        <div
          :class="['item', selectItem.name == item.name ? 'actives' : '']"
          v-for="(item, index) in leftList"
          :key="index"
          @mouseover="selectPage(item)"
          @click="selectFirst(item)"
        >
          <!-- <img
            :src="item.icon"
            alt=""
            class="img0"
            v-if="selectItem.name == item.name"
          />
          <img :src="item.icon1" alt="" class="img0" v-else /> -->
          <i :class="['iconfont', 'icon-' + item.icon]"></i>
          <div class="leftTitle">{{ item.name }}</div>
          <!-- <img
            src="../assets/imgs/icon_right.png"
            alt=""
            class="rightIcon"
            v-if="item.children.length > 0"
          /> -->
        </div>
      </div>
      <!-- <div
        class="secondBox"
        v-if="
          selectItem && selectItem.children && selectItem.children.length > 0
        "
      >
        <div class="item_box rightBox" style="width: 130px;">
          <div class="secondTitle">{{ selectItem.name }}</div>
          <div class="secondList">
            <div
              v-for="(item1, index) in selectItem.children"
              :class="['item', selectItem1.name == item1.name ? 'actives' : '']"
              :key="index"
              @mouseover="selectPage1(item1)"
              @click="selectSecond(item1)"
            >
              <div class="leftTitle">{{ item1.name }}</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    leftList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectItem: {}, // 选中的左侧列表数据
      selectItem1: {} // 选中的左侧二级列表数据
    };
  },
  created() {
    let str = this.$route.path;
    if (this.leftList.length != 0) {
      for (var i = 0; i < this.leftList.length; i++) {
        if (str == this.leftList[i].url) {
          this.selectItem = this.leftList[i];
        } else {
          if (this.leftList[i].children) {
            for (var z = 0; z < this.leftList[i].children.length; z++) {
              if (str == this.leftList[i].children[z].url) {
                this.selectItem = this.leftList[i];
              }
            }
          }
        }
      }
    }
  },
  methods: {
    //鼠标移入左侧菜单
    selectPage(val) {},
    //鼠标点击左侧菜单
    selectFirst(val) {
      this.$router.push(val.url);
    },
    //鼠标移入右侧菜单
    selectPage1(val) {},
    //鼠标点击右侧菜单
    selectSecond(val) {
      this.selectItem1 = val;
      this.$router.push(val.url);
    }
  }
};
</script>
<style scoped>
.secondTitle {
  text-align: center;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1d2129;
  line-height: 28px;
}
.actives {
  color: #165dff;
}
.rightBox {
  height: 100%;
  padding: 25px 0;
  box-sizing: border-box;
}
.secondBox {
  width: 130px;
  text-align: center;
  display: none;
  position: absolute;
  top: 0;
  left: 170px;
  background: #fff;
  border-radius: 0 8px 8px 0;
  min-height: 80vh;
  border-left: solid 1px #e5e6eb;
}
.box_left {
  background: #fff;
  padding: 0 20px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4e5969;
  line-height: 22px;
  border-radius: 8px;
  display: inline-block;
  z-index: 99;
  min-height: 80vh;
  height: 100%;
  margin-right: 16px;
}
.item_box {
  width: 156px;
  height: 100%;
  padding: 12px 0;
  box-sizing: border-box;
}
.box_left:hover {
  background: #fff;
  box-shadow: 0px 0px 20px 0px rgba(0, 35, 114, 0.1);
}
.box_left:hover .secondBox {
  display: block;
  box-shadow: 0px 8px 20px 0px rgba(0, 35, 114, 0.1);
}
.rightIcon {
  display: none;
  width: 16px;
  height: 16px;
}
.box_left:hover .rightIcon {
  display: block;
}
.item {
  padding: 13px 0 13px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  /* justify-content: center; */
}
.img0 {
  width: 25px;
  height: 25px;
  margin-right: 8px;
}
.leftTitle {
  margin-left: 8px;
}
</style>
